/**
 * Token persistence — localStorage backed.
 *
 * Why localStorage and not a cookie (orion-frontend used js-cookie):
 * - We send the token in the `Authorization` header, never relying on
 *   cookie auth. A cookie buys us nothing here and adds SameSite/Secure
 *   semantics we'd just have to work around in dev.
 * - localStorage survives full reloads and is trivially testable.
 *
 * Single key, no encryption. If someone has access to the user's
 * localStorage they already have access to the running app — encrypting
 * the token in-place would be theatre.
 */

const STORAGE_KEY = "orion.auth.token";

export function readToken(): string | null {
    try {
        return localStorage.getItem(STORAGE_KEY);
    } catch {
        // Private-mode Safari etc. — fall back to "no token".
        return null;
    }
}

export function writeToken(token: string): void {
    try {
        localStorage.setItem(STORAGE_KEY, token);
    } catch {
        // Quota / private-mode — caller will surface the failure
        // through the login flow if it matters.
    }
}

export function clearToken(): void {
    try {
        localStorage.removeItem(STORAGE_KEY);
    } catch {
        // ignore
    }
}
